import React, { useEffect } from "react";
import "./gameRules.css";
import logoBlue from "../../components/images/logoblue.png";
import { Link, useHistory } from "react-router-dom";
import { ArrowBack } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchRules } from "../../redux/actions/gameRulesAction.js";

export default function GameRules() {
  const dispatch = useDispatch();
  const history = useHistory();
  const ruleData = useSelector((state) => state.gameRules.rules);
  const loading = useSelector((state) => state.gameRules.loading);

  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem("myData"));
    dispatch(fetchRules(data));
  }, [dispatch]);

  return (
    <div className="gameRules">
      <div className="gameRulesHeader">
        <div className="titleWithBack">
          <button className="backBtn" onClick={() => history.goBack()}>
            <ArrowBack className="backBtnIcon" />
          </button>
          <h1 className="gameRulesTitle">Game Rules</h1>
        </div>
        <img
          className="gameRulesLogo"
          src={logoBlue}
          alt="logo"
          width="150px"
        ></img>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        ruleData?.map((item) => (
          <div className="rulesContainer" key={item._id}>
            <h1 className="rulesTxt">{item?.ruleName}</h1>

            <div className="ageView">
              <p className="age">Gender: {item?.gender}</p>
              <div className="line" />
              <p className="age">Code: {item?.ruleId}</p>
            </div>

            <Link to={"/ruleDetails/" + item._id}>
              <button className="viewBtn">
                VIEW DETAILS
              </button>
            </Link>
          </div>
        ))
      )}

      <div className="gameRuleAdd">
        <Link to={"/addRule"}>
          <button className="plusBtn">+</button>
        </Link>
      </div>
    </div>
  );
}
